import styles from '../Navigation.module.scss'
import NavigationItem from '../navigation-item/NavigationItem.tsx'
import { routes } from 'types/routes.ts'
import { useTranslation } from 'react-i18next'
import { memo, useLayoutEffect, useState } from 'react'
import { SalesNavigationProps } from '../types.ts'
import LanguageSwitchBar from 'components/language-switch-bar/LanguageSwitchBar.tsx'
import { Button } from '@boltenergy-be/design-system'
import { getPersistedItem, setPersistedItem } from 'utils/persistedStorage.ts'
import { SIDEBAR_COLLAPSED_STORAGE_KEY, SIDEBAR_WIDTH_COLLAPSED, SIDEBAR_WIDTH_EXPANDED, SIDEBAR_WIDTH_VARIABLE } from '../constants.ts'
import { useStoreSelector } from 'hooks/store.ts'
import { ROLES } from '@boltenergy-be/shared'

const DesktopSalesNavigation = memo(({ handleLogout }: SalesNavigationProps) => {
  // Redux
  const { role } = useStoreSelector((store) => store.sales)

  // i18n
  const { t } = useTranslation()

  // Local state
  const [collapsed, setCollapsed] = useState<boolean>(getPersistedItem(SIDEBAR_COLLAPSED_STORAGE_KEY) === 'true')

  /**
   * Toggle sidebar collapse
   */
  const toggleSidebarCollapse = () => {
    const newState = !collapsed
    setCollapsed(newState)
    setPersistedItem(SIDEBAR_COLLAPSED_STORAGE_KEY, newState.toString())
  }

  useLayoutEffect(() => {
    document.documentElement.style.setProperty(SIDEBAR_WIDTH_VARIABLE, collapsed ? SIDEBAR_WIDTH_COLLAPSED : SIDEBAR_WIDTH_EXPANDED)
  }, [collapsed])

  return (
    <aside className={styles['navigation-wrapper']}>
      <LanguageSwitchBar compact sticky collapsed={collapsed} />

      <nav className={styles.navigation} aria-labelledby="main">
        <ul className={styles['nav-items-list']}>
          <NavigationItem icon="homeSmile" text={t(($) => $.nav.overview)} url={routes.SALES_HOME} collapsed={collapsed} />
          <NavigationItem icon="file" text={t(($) => $.nav.events)} url={routes.SALES_EVENTS} collapsed={collapsed} />
          {(role === ROLES.salesManager || role === ROLES.salesTeamLead) && (
            <NavigationItem icon="charts" text={t(($) => $.nav.salesDashboard)} url={routes.SALES_DASHBOARD} collapsed={collapsed} />
          )}
          <NavigationItem icon="logOut" text={t(($) => $.nav.logout)} onClick={handleLogout} id="logout" collapsed={collapsed} />
        </ul>

        <Button
          className={styles['collapse-trigger']}
          variant="tertiary"
          leadingIcon={collapsed ? 'chevronSlider' : 'chevronLeft'}
          onClick={toggleSidebarCollapse}
          isFullwidth
          title={collapsed ? 'Expand' : undefined}
        >
          {!collapsed && 'Collapse'}
        </Button>
      </nav>
    </aside>
  )
})

DesktopSalesNavigation.displayName = 'DesktopSalesNavigation'

export default DesktopSalesNavigation
